import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ExpirationStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-expirationstatus',
  templateUrl: './expirationstatus.component.html',
  styleUrls: ['./expirationstatus.component.scss']
})
export class ExpirationStatusComponent implements OnChanges {


  expirationstatusForm: FormGroup;
  expirationstatusFormArray: FormGroup;
  control = new FormControl();
  @Input() expirationstatuss: ExpirationStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() expirationstatus = new EventEmitter<ExpirationStatusDto[]>()
  @Output() deleteExpirationStatusEvent = new EventEmitter<any>()

    selectedExpirationStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createExpirationStatusForm();
    }

    createExpirationStatusForm() {
      this.expirationstatusForm = this.fb.group({
        ExpirationStatusName: ['', Validators.required],
     
        id: null
        });
        this.expirationstatusFormArray = this.fb.group({ ExpirationStatuss: this.fb.array([])
          });
        this.setExpirationStatus();
    }

  // method to display expirationstatuss
  setExpirationStatus() {
    const control  = this.expirationstatusFormArray.controls.ExpirationStatuss as FormArray;
    this.expirationstatuss.forEach( e => {
      control.push(
        this.fb.group({
          ExpirationStatusName: e.ExpirationStatusName,
        
          id: e.id
        })
      );
    });
  }


  // method to add ExpirationStatus
  addExpirationStatus(value: ExpirationStatusDto) {
    const control  = this.expirationstatusFormArray.controls.ExpirationStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            ExpirationStatusName: value.ExpirationStatusName,
          
            id: null
          })
       );
  }

  selectExpirationStatus(value) {}

  // method to delete expirationstatus from arrary list
  deleteExpirationStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.expirationstatusFormArray.controls.ExpirationStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.expirationstatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.expirationstatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: ExpirationStatusDto) {
    if(this.expirationstatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.expirationstatusFormArray.get('ExpirationStatuss')['controls'][this.selectedIndex].patchValue({ExpirationStatusName: formValue.ExpirationStatusName});
    } else {
      this.addExpirationStatus(formValue);
    }
    this.selectedIndex = null;
    this.expirationstatusForm.reset()
  }

  onEdit(index, value: ExpirationStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.expirationstatusForm.patchValue({ExpirationStatusName: value.ExpirationStatusName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.expirationstatusForm.reset();
  }

  onSubmit(formValue: ExpirationStatusDto[]) {
  this.expirationstatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteExpirationStatusEvent.emit(this.filteredDelete);
  }
  }

}
